/**
 * Returns an appropriate icon based on the message content for enhanced logging
 *
 * @param {string} message - The log message to analyze
 * @returns {string} - An emoji icon that matches the message content
 */
export const getLogIcon = (message) => {
  if (!message) return '';

  // Database operations
  if (message.includes('DELETE') || message.includes('delete')) return '🗑️ ';
  if (message.includes('Database')) return '🗄️ ';

  // Processing states
  if (message.includes('processing')) return '⚙️ ';
  if (message.includes('checking')) return '🔍 ';
  if (message.includes('mounted')) return '🔌 ';
  if (message.includes('cleanup')) return '🧹 ';

  // Status indicators
  if (message.includes('Updates') || message.includes('update')) return '🔄 ';
  if (message.includes('Initialized')) return '🚀 ';
  if (message.includes('Prevented') || message.includes('Error')) return '🛑 ';
  if (message.includes('Initial Create') || message.includes('new'))
    return '🆕 ';
  if (message.includes('complete') || message.includes('success')) return '✅ ';

  // Form Manager specific
  if (message.includes('Form Values')) return '📝 '; // Form value changes
  if (message.includes('Initial') && !message.includes('Create')) return '🔰 '; // Initial/starting values
  if (message.includes('State') && !message.includes('Form State'))
    return '💾 '; // State changes

  // Component type indicators
  if (message.includes('Manager')) return '📋 '; // Form Manager

  // Default
  return '💾 '; // Default disk/save icon
};

/**
 * Logger utility for application-wide logging with status and color support
 *
 * @param {string} title - The title or category of the log
 * @param {string} message - The log message
 * @param {any} data - Optional data to include with the log
 * @param {string} status - Log status: 'info', 'error', or 'success' (defaults to 'info')
 */
const logger = (title, message, data, status = 'info') => {
  // Use the utility function to get the appropriate icon
  const icon = getLogIcon(message);

  // Define styles for different status types
  const styles = {
    error: 'color: #ff5555; font-weight: bold',
    success: 'color: #4caf50; font-weight: bold',
    info: 'color: inherit',
  };

  // Use the style for the selected status, default to info style
  const style = styles[status] || styles.info;

  const formattedMessage = `${icon}[${title}] ${message}`;

  if (data) {
    console.log(`%c${formattedMessage}`, style, data);
  } else {
    console.log(`%c${formattedMessage}`, style);
  }
};

export default logger;
